import {
  STRING_getInstance3lkmlozu5h7cs as STRING_getInstance,
  INT_getInstance2jk920d18c81r as INT_getInstance,
  BOOLEAN_getInstance1zgqob6plbafc as BOOLEAN_getInstance,
  DOUBLE_getInstancehisd1jhl157p as DOUBLE_getInstance,
  LONG_getInstance3dslxry3kuylr as LONG_getInstance,
  BYTE_getInstance3pm2k5kbbzz0g as BYTE_getInstance,
  SHORT_getInstancef43vhew9c0zf as SHORT_getInstance,
  CHAR_getInstance13nfcvgyx04s8 as CHAR_getInstance,
  FLOAT_getInstance10ku33lzbmw7c as FLOAT_getInstance,
} from '../descriptors/SerialKinds.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../descriptors/SerialDescriptor.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from './ObjectSerializer.mjs';
import { initBuiltins3cd82qqvse108 as initBuiltins } from './Platform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
var StringSerializerClass;
function StringSerializer() {
  if (StringSerializerClass === VOID) {
    class $ {
      constructor() {
        StringSerializer_instance = this;
        this.h24_1 = new (PrimitiveSerialDescriptor())('kotlin.String', STRING_getInstance());
      }
      h1m() {
        return this.h24_1;
      }
      i24(encoder, value) {
        return encoder.d1s(value);
      }
      i1m(encoder, value) {
        return this.i24(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j1m(decoder) {
        return decoder.t1q();
      }
    }
    initMetadataForObject($, 'StringSerializer', VOID, VOID, [KSerializer()]);
    StringSerializerClass = $;
  }
  return StringSerializerClass;
}
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance === VOID)
    new (StringSerializer())();
  return StringSerializer_instance;
}
var IntSerializerClass;
function IntSerializer() {
  if (IntSerializerClass === VOID) {
    class $ {
      constructor() {
        IntSerializer_instance = this;
        this.j24_1 = new (PrimitiveSerialDescriptor())('kotlin.Int', INT_getInstance());
      }
      h1m() {
        return this.j24_1;
      }
      k24(encoder, value) {
        return encoder.y1r(value);
      }
      i1m(encoder, value) {
        return this.k24(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j1m(decoder) {
        return decoder.o1q();
      }
    }
    initMetadataForObject($, 'IntSerializer', VOID, VOID, [KSerializer()]);
    IntSerializerClass = $;
  }
  return IntSerializerClass;
}
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance === VOID)
    new (IntSerializer())();
  return IntSerializer_instance;
}
var BooleanSerializerClass;
function BooleanSerializer() {
  if (BooleanSerializerClass === VOID) {
    class $ {
      constructor() {
        BooleanSerializer_instance = this;
        this.l24_1 = new (PrimitiveSerialDescriptor())('kotlin.Boolean', BOOLEAN_getInstance());
      }
      h1m() {
        return this.l24_1;
      }
      m24(encoder, value) {
        return encoder.v1r(value);
      }
      i1m(encoder, value) {
        return this.m24(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j1m(decoder) {
        return decoder.l1q();
      }
    }
    initMetadataForObject($, 'BooleanSerializer', VOID, VOID, [KSerializer()]);
    BooleanSerializerClass = $;
  }
  return BooleanSerializerClass;
}
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance === VOID)
    new (BooleanSerializer())();
  return BooleanSerializer_instance;
}
var DoubleSerializerClass;
function DoubleSerializer() {
  if (DoubleSerializerClass === VOID) {
    class $ {
      constructor() {
        DoubleSerializer_instance = this;
        this.n24_1 = new (PrimitiveSerialDescriptor())('kotlin.Double', DOUBLE_getInstance());
      }
      h1m() {
        return this.n24_1;
      }
      o24(encoder, value) {
        return encoder.b1s(value);
      }
      i1m(encoder, value) {
        return this.o24(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j1m(decoder) {
        return decoder.r1q();
      }
    }
    initMetadataForObject($, 'DoubleSerializer', VOID, VOID, [KSerializer()]);
    DoubleSerializerClass = $;
  }
  return DoubleSerializerClass;
}
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance === VOID)
    new (DoubleSerializer())();
  return DoubleSerializer_instance;
}
var LongSerializerClass;
function LongSerializer() {
  if (LongSerializerClass === VOID) {
    class $ {
      constructor() {
        LongSerializer_instance = this;
        this.p24_1 = new (PrimitiveSerialDescriptor())('kotlin.Long', LONG_getInstance());
      }
      h1m() {
        return this.p24_1;
      }
      q24(encoder, value) {
        return encoder.z1r(value);
      }
      i1m(encoder, value) {
        return this.q24(encoder, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      j1m(decoder) {
        return decoder.p1q();
      }
    }
    initMetadataForObject($, 'LongSerializer', VOID, VOID, [KSerializer()]);
    LongSerializerClass = $;
  }
  return LongSerializerClass;
}
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance === VOID)
    new (LongSerializer())();
  return LongSerializer_instance;
}
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().u4(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer())) ? tmp : THROW_CCE();
}
function checkNameIsNotAPrimitive(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var values = get_BUILTIN_SERIALIZERS().w4();
  var _iterator__ex2g4s = values.p1();
  while (_iterator__ex2g4s.q1()) {
    var primitive = _iterator__ex2g4s.r1();
    var primitiveName = primitive.h1m().k1n();
    if (serialName === primitiveName) {
      throw IllegalArgumentException().n2(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).j1() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkNameIsNotAPrimitive(serialName);
  return new (PrimitiveSerialDescriptor())(serialName, kind);
}
function error($this) {
  throw IllegalStateException().o('Primitive descriptor ' + $this.r24_1 + ' does not have elements');
}
var PrimitiveSerialDescriptorClass;
function PrimitiveSerialDescriptor() {
  if (PrimitiveSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, kind) {
        this.r24_1 = serialName;
        this.s24_1 = kind;
      }
      k1n() {
        return this.r24_1;
      }
      d1p() {
        return this.s24_1;
      }
      f1p() {
        return 0;
      }
      h1p(index) {
        error(this);
      }
      i1p(name) {
        error(this);
      }
      l1p(index) {
        error(this);
      }
      k1p(index) {
        error(this);
      }
      j1p(index) {
        error(this);
      }
      toString() {
        return 'PrimitiveDescriptor(' + this.r24_1 + ')';
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PrimitiveSerialDescriptor()))
          return false;
        if (this.r24_1 === other.r24_1 && equals(this.s24_1, other.s24_1))
          return true;
        return false;
      }
      hashCode() {
        return getStringHashCode(this.r24_1) + imul(31, this.s24_1.hashCode()) | 0;
      }
    }
    protoOf($).w1o = get_isNullable;
    protoOf($).e1p = get_isInline;
    protoOf($).g1p = get_annotations;
    initMetadataForClass($, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    PrimitiveSerialDescriptorClass = $;
  }
  return PrimitiveSerialDescriptorClass;
}
var ByteSerializerClass;
function ByteSerializer() {
  if (ByteSerializerClass === VOID) {
    class $ {
      constructor() {
        ByteSerializer_instance = this;
        this.t24_1 = new (PrimitiveSerialDescriptor())('kotlin.Byte', BYTE_getInstance());
      }
      h1m() {
        return this.t24_1;
      }
      u24(encoder, value) {
        return encoder.w1r(value);
      }
      i1m(encoder, value) {
        return this.u24(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j1m(decoder) {
        return decoder.m1q();
      }
    }
    initMetadataForObject($, 'ByteSerializer', VOID, VOID, [KSerializer()]);
    ByteSerializerClass = $;
  }
  return ByteSerializerClass;
}
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance === VOID)
    new (ByteSerializer())();
  return ByteSerializer_instance;
}
var ShortSerializerClass;
function ShortSerializer() {
  if (ShortSerializerClass === VOID) {
    class $ {
      constructor() {
        ShortSerializer_instance = this;
        this.v24_1 = new (PrimitiveSerialDescriptor())('kotlin.Short', SHORT_getInstance());
      }
      h1m() {
        return this.v24_1;
      }
      w24(encoder, value) {
        return encoder.x1r(value);
      }
      i1m(encoder, value) {
        return this.w24(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j1m(decoder) {
        return decoder.n1q();
      }
    }
    initMetadataForObject($, 'ShortSerializer', VOID, VOID, [KSerializer()]);
    ShortSerializerClass = $;
  }
  return ShortSerializerClass;
}
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance === VOID)
    new (ShortSerializer())();
  return ShortSerializer_instance;
}
var CharSerializerClass;
function CharSerializer() {
  if (CharSerializerClass === VOID) {
    class $ {
      constructor() {
        CharSerializer_instance = this;
        this.x24_1 = new (PrimitiveSerialDescriptor())('kotlin.Char', CHAR_getInstance());
      }
      h1m() {
        return this.x24_1;
      }
      y24(encoder, value) {
        return encoder.c1s(value);
      }
      i1m(encoder, value) {
        return this.y24(encoder, value instanceof Char() ? value.e4_1 : THROW_CCE());
      }
      z24(decoder) {
        return decoder.s1q();
      }
      j1m(decoder) {
        return new (Char())(this.z24(decoder));
      }
    }
    initMetadataForObject($, 'CharSerializer', VOID, VOID, [KSerializer()]);
    CharSerializerClass = $;
  }
  return CharSerializerClass;
}
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance === VOID)
    new (CharSerializer())();
  return CharSerializer_instance;
}
var FloatSerializerClass;
function FloatSerializer() {
  if (FloatSerializerClass === VOID) {
    class $ {
      constructor() {
        FloatSerializer_instance = this;
        this.a25_1 = new (PrimitiveSerialDescriptor())('kotlin.Float', FLOAT_getInstance());
      }
      h1m() {
        return this.a25_1;
      }
      b25(encoder, value) {
        return encoder.a1s(value);
      }
      i1m(encoder, value) {
        return this.b25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j1m(decoder) {
        return decoder.q1q();
      }
    }
    initMetadataForObject($, 'FloatSerializer', VOID, VOID, [KSerializer()]);
    FloatSerializerClass = $;
  }
  return FloatSerializerClass;
}
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance === VOID)
    new (FloatSerializer())();
  return FloatSerializer_instance;
}
var UnitSerializerClass;
function UnitSerializer() {
  if (UnitSerializerClass === VOID) {
    class $ {
      constructor() {
        UnitSerializer_instance = this;
        this.c25_1 = new (ObjectSerializer())('kotlin.Unit', Unit_instance);
      }
      h1m() {
        return this.c25_1.h1m();
      }
      d25(encoder, value) {
        this.c25_1.b1n(encoder, Unit_instance);
      }
      i1m(encoder, value) {
        return this.d25(encoder, value instanceof Unit() ? value : THROW_CCE());
      }
      e25(decoder) {
        this.c25_1.j1m(decoder);
      }
      j1m(decoder) {
        this.e25(decoder);
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'UnitSerializer', VOID, VOID, [KSerializer()]);
    UnitSerializerClass = $;
  }
  return UnitSerializerClass;
}
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance === VOID)
    new (UnitSerializer())();
  return UnitSerializer_instance;
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = initBuiltins();
  }
}
//region block: exports
export {
  BooleanSerializer_getInstance as BooleanSerializer_getInstance2fsi2wywr82nt,
  ByteSerializer_getInstance as ByteSerializer_getInstance1nxlqf2s1e0d6,
  CharSerializer_getInstance as CharSerializer_getInstance1yoquzs1oia4q,
  DoubleSerializer_getInstance as DoubleSerializer_getInstance1wncowm4p8ecy,
  FloatSerializer_getInstance as FloatSerializer_getInstance1qugdr7bzigck,
  IntSerializer_getInstance as IntSerializer_getInstanceuhm8c1wku08l,
  LongSerializer_getInstance as LongSerializer_getInstance2fim4572ialei,
  ShortSerializer_getInstance as ShortSerializer_getInstanceiv7zxiav6sho,
  StringSerializer_getInstance as StringSerializer_getInstance11v9md0a7d9yk,
  UnitSerializer_getInstance as UnitSerializer_getInstance2ron9qqcvf5sr,
  PrimitiveDescriptorSafe as PrimitiveDescriptorSafe1r3pht5v1oaqu,
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptorkwnwsc78b2on,
  builtinSerializerOrNull as builtinSerializerOrNull180kp99qvlpex,
  checkNameIsNotAPrimitive as checkNameIsNotAPrimitive28vmhppr4nskt,
};
//endregion

//# sourceMappingURL=Primitives.mjs.map
